import React from 'react';
import { Grid, Paper, Table, TableHead, TableBody, TableCell, TableRow,
		 TablePagination,
		 Button} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import LazyBox from '../../../web/components/LazyBox';
import { CSVLink } from "react-csv";

// services
import ContatoAPI from '../../../services/api/Contato';

import { formatTel } from '../../../utils/format';

const headers = [
	{ label: "Nome", key: "nome" },
	{ label: "Email", key: "email" },
	{ label: "Telefone", key: "telefone" }
  ];

class Contatos extends React.Component {
	state = {
		page:0,
		rowsPerPage: 5,
		contatos:[],
		loading: true,
	}

	refreshContatos = () => {
		const { enqueueSnackbar } = this.props;
		ContatoAPI.lista()
		.then(res => {
			res.json().then(res => {
				if (res.msg) {
					this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
					return;
				}
				this.setState({ contatos: res, loading: false })
				return;
			})
		}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel carregar a lista')))
	}

	componentDidMount(){
		this.refreshContatos();
	}

    render() {
		const { page, rowsPerPage, contatos, loading } = this.state;
        return (
				<div>
					<div className="app_control__content_padding" >
						<LazyBox loading={loading} height="80vh" >
							<Grid container spacing={32} >
								<Grid item xs={12} >
									<Button component={CSVLink}
											filename={`contatos_site_${new Date().getTime()}.csv`}
											data={contatos}
											headers={headers}
											variant="outlined"
											color="primary" > Exporta em CSV </Button>
								</Grid>
								<Grid item xs={12} >
									<Paper elevation={0} >
										<Table>
											<TableHead>
												<TableRow>
													<TableCell>Nome</TableCell>
													<TableCell>Email</TableCell>
													<TableCell>Telefone</TableCell>
													<TableCell>Data Cadastro</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{contatos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((c,k) => <TableRow key={k} >
													<TableCell>{c.nome}</TableCell>
													<TableCell>{c.email}</TableCell>
													<TableCell>{formatTel(String(c.telefone))}</TableCell>
													<TableCell>{moment(c.data_cadastro).format("DD/MM/YYYY [às] HH:MM")}</TableCell>
												</TableRow>)}
											</TableBody>
										</Table>
										<TablePagination
											rowsPerPageOptions={[5, 10, 25]}
											component="div"
											count={contatos.length}
											rowsPerPage={rowsPerPage}
											page={page}
											backIconButtonProps={{
												'aria-label': 'Anterior',
											}}
											nextIconButtonProps={{
												'aria-label': 'Próximo',
											}}
											labelDisplayedRows={({from,to,count}) => `Exibindo de ${from} à ${to} de ${count}`}
											labelRowsPerPage={`Registros por página`}
											onChangePage={(event,pagina) => this.setState({ page: pagina })}
											onChangeRowsPerPage={(event,qtd) => this.setState({ rowsPerPage: Number(qtd.key) })}
										/>
									</Paper>
								</Grid>
							</Grid>
						</LazyBox>
					</div>
				</div>
        );
    }
}


export default withSnackbar(Contatos);



// WEBPACK FOOTER //
// ./src/painel/pages/contatos/index.js